(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_carousel_004 = {
    attach: function (context, settings) {

      var carousels = [];

      function stepSize() {
        $('.mbo-carousel-004').each(function(index) {
          if ($(this).find('.field--name-field-o-carousel-items--images').length >= 1) {

            var indexClass = '.mbo-carousel-004-item-' + index;

            var carouselItems = indexClass + ' .field--name-field-o-carousel-items--content';

            if (!$(carouselItems).parent().hasClass('single-item-carousel')) {

              var largest = 0;

              $(carouselItems).find('.slick-slide').each(function () {
                $(this).css('height', '100%');
                if ($(this).height() > largest) {
                  largest = $(this).height();
                }
              });

              $(carouselItems).find('.slick-slide').each(function () {
                $(this).css('height', largest + 30);
              });
            }
          }
        });
      }

      // --- Loop through .mbo-carousel-004 --- //
      $('.mbo-carousel-004').each(function(index) {
        if ($(this).find('.field--name-field-o-carousel-items--images>.field__item').length >= 1) {

          // --- Add unique CSS class --- //
          var indexClass = 'mbo-carousel-004-item-' + index;

          $(this).addClass(indexClass);

          indexClass = '.' + indexClass;

          var slickCarouselImages = $(indexClass + ' .field--name-field-o-carousel-items--images', context).once('slick-images');
          var slickCarouselContent = $(indexClass + ' .field--name-field-o-carousel-items--content', context).once('slick-content');

          // --- Initialise slick carousels --- //
          slickCarouselImages.slick({
            dots: true,
            infinite: true,
            prevArrow: false,
            nextArrow: false,
            asNavFor: indexClass + ' .field--name-field-o-carousel-items--content',
            swipe: false
          });

          slickCarouselContent.slick({
            infinite: true,
            fade: true,
            prevArrow: false,
            nextArrow: false,
            asNavFor: indexClass + ' .field--name-field-o-carousel-items--images',
            swipe: false
          });

          var object = {
            'this': $(this),
            'paused': true,
            'origtime': 4000,
            'timeleft': this.origtime,
            'interval': 30,
            'timer': null
          };

          carousels.push(object);

          var carouselItems = indexClass + ' .field--name-field-o-carousel-items--content';
          if ($(carouselItems).find('.slick-slide').length === 1) {
            $(carouselItems).addClass('single-item-margin');
            $(carouselItems).parent().addClass('single-item-carousel');
            $(carouselItems).find('.carousel-progress-wrapper').hide();
            $(carouselItems).find('.slick-arrow-navigation button').hide();
          }

          if($(carouselItems).find('.field--name-field-m-button-items').length <= 0) {
            $(carouselItems).find('.field--name-field-m-carousel-heading').addClass('no-buttons-heading');
          }

        }
      }); //$('.mbo-carousel-004').each();

      stepSize();
      $(window).on('resize', function(){
        stepSize();
      });

      var carouselsLength = carousels.length;

      // Start auto scroll
      for (var i = 0; i < carouselsLength; i++) {

        carousels[i].paused = false;
        createInterval(plusSlides, i, carousels[i].interval);

      }

      /**
       * Creates the timer for a carousel.
       *
       * @param f
       * @param i
       * @param interval
       */
      function createInterval(f,i,interval) {
        carousels[i].timer = setInterval(function() {
          f(carousels[i]);
        }, interval);
      }

      /**
       * Moves the carousel slides along.
       *
       * @param carousel
       */
      function plusSlides(carousel) {
        clearInterval(carousel.timer);
        if (!carousel.paused) {
          if ((carousel.timeleft - carousel.interval) > 0) {
            carousel.timeleft -= carousel.interval;
          } else {
            carousel.timeleft = carousel.origtime;
            carousel.this.find('.field--name-field-o-carousel-items--content').slick('slickNext');
          }
          displayProgress(carousel);
        }
        carousel.timer = setInterval(function() {
          plusSlides(carousel);
        }, carousel.interval);
      }

      /**
       * Displays the progress until the next slide.
       *
       * @param carousel
       */
      function displayProgress(carousel) {
        var percentage = 100 - (carousel.timeleft / carousel.origtime * 100)  + '%';
        carousel.this.find('.carousel-progress').css('width', percentage);
      }

      /**
       * Reset carousel to 0 progress.
       *
       * @param i
       */
      function resetProgress(i) {
        if (carousels.length) {
          carousels[i].timeleft = carousels[i].origtime;
          displayProgress(carousels[i]);
        }
      }

      /**
       * Update the paused setting.
       *
       * @param i
       * @param pause
       */
      function pauseCarousel(i, pause) {
        if (carousels.length) {
          carousels[i].paused = pause;
        }
      }

      // Pause on hover.
      $('body').once('carousel_004_pause').on('mouseenter', '.field--name-field-o-carousel-items--content', function() {
        if (!$('body').hasClass('touch-enabled')) {
          var parent = getParentIndex($(this));
          if (parent !== false) {
            pauseCarousel(parent, true);
          }
        }
      }).on('mouseleave', '.field--name-field-o-carousel-items--content', function() {
        var parent = getParentIndex($(this));
        if (parent !== false) {
          pauseCarousel(parent, false);
        }
      });

      function getParentIndex (obj) {
        var index = false;

        if (typeof obj === 'object') {

          var parent = obj.parent(".mbo-carousel-004");

          if (typeof parent === 'object') {
            var classString = parent.attr('class');

            if (typeof classString !== 'undefined') {
              var classes = classString.split(' ');

              $.each(classes, function (i, val) {
                if (val.indexOf("mbo-carousel-004-item") !== -1) {
                  var parts = val.split("-");
                  index = parts[parts.length - 1];
                }
              });
            }
          }

        }

        return index;
      }

      $(".field--name-field-o-carousel-items--images").on('beforeChange', function(event, slick, direction) {

        var parent = getParentIndex($(this));

        if (parent !== false) {
          resetProgress(parent);
        }

      });

      // --- Next and previous navigation click event --- //
      $('.mbo-carousel-004--content .slick-arrow-navigation button').click(function() {

        var thisSlickCarouselImages = $(this).parents('.field--name-field-o-carousel-items--content');

        if ( $(this).hasClass('slick-arrow-navigation--prev') ) thisSlickCarouselImages.slick('slickPrev');
        if ( $(this).hasClass('slick-arrow-navigation--next') ) thisSlickCarouselImages.slick('slickNext');
      });

      // --- Hover animations --- //
      $('.mbo-carousel-004--content .field--name-field-m-carousel-buttons .field__item:first-child .clickable-mask').once('carousel-004-hovers').on('mouseenter', function(){
        $(this).closest('.mbo-carousel-004--content').addClass('hovering');
      }).on('mouseleave', function(){
        $(this).closest('.mbo-carousel-004--content').removeClass('hovering');
      });

    }
  }; //Drupal.behaviors.mbo_carousel_004

})(jQuery, Drupal, drupalSettings);

